export default function Logo({ compact = false, mobileCompact = false }) {
    return (
        <a
            href="/"
            data-testid="nav-logo"
            className="flex items-center gap-3"
            aria-label="Jetski Paradise Ubatuba — início"
        >
            <svg
                viewBox="0 0 32 32"
                className="h-9 w-9 shrink-0"
                aria-hidden="true"
            >
                <rect
                    width="32"
                    height="32"
                    rx="8"
                    fill="#0D1527"
                    stroke="rgba(0,240,255,0.3)"
                />
                <path
                    d="M7 15.5 20.5 7.5l5.5 3.2-10.5 6.2z"
                    fill="#00E5A3"
                />
                <path
                    d="M4 21.5c3-2.4 5.5-2.4 8.5 0s5.5 2.4 8.5 0 5-2.4 7-1"
                    stroke="#00F0FF"
                    strokeWidth="2.4"
                    fill="none"
                    strokeLinecap="round"
                />
                <circle cx="25.5" cy="8.5" r="1.7" fill="#FFD166" />
            </svg>
            {!compact && (
                <span className={mobileCompact ? "hidden min-[390px]:block leading-tight" : "leading-tight"}>
                    <span className="block font-display text-[13px] font-extrabold uppercase tracking-wide text-ink">
                        Jetski Paradise
                    </span>
                    <span className="block font-mono2 text-[9px] font-semibold uppercase tracking-[0.35em] text-neon-cyan">
                        Ubatuba — SP
                    </span>
                </span>
            )}
        </a>
    );
}
